export default {
    test: {
      hello: 'Hello',
      world: 'World'
    },
    common: {
        title: 'Shennong Wenqiong Large Model'
      },
    layers: {
      wind: 'Wind Speed',
      temperature: 'Temperature',
      humidity: 'Humidity',
      precipitation: 'Precipitation',
      more: 'More',
      latlng: 'Lat/Lng Grid',
      port: 'Ports',
      device: 'Facilities',
      warningLine: 'Warning Circle',
      pipeLine: 'Pipeline',
      ship: 'Ships'
    }
  }